import { toast, type ToastOptions } from 'react-toastify';
import { DSIcon } from '@eiv2/design-system';

const baseOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 4000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  closeButton: false,
  icon: false
};

function ToastContent({
  icon,
  message
}: {
  icon: 'TickCircle' | 'InfoCircle';
  message: string;
}) {
  return (
    <div className="flex items-center gap-2">
      <DSIcon className="shrink-0 text-body-light-mode-1" name={icon} size={24} variant="Bold" />
      <span className="text-[14px] font-semibold leading-normal text-body-light-mode-1">{message}</span>
    </div>
  );
}

export function toastSuccess(message: string, options?: ToastOptions) {
  return toast.success(<ToastContent icon="TickCircle" message={message} />, {
    ...baseOptions,
    className: 'ei-toast ei-toast--success',
    ...options
  });
}

export function toastError(message: string, options?: ToastOptions) {
  return toast.error(<ToastContent icon="InfoCircle" message={message} />, {
    ...baseOptions,
    className: 'ei-toast ei-toast--error',
    ...options
  });
}
